import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="relative border-t border-neutral-900 bg-black pt-24 pb-12 text-neutral-400 overflow-hidden">
      {/* Subtle background glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(223,181,135,0.02),transparent_50%)] pointer-events-none" />

      <div className="mx-auto max-w-[1600px] px-6 md:px-12 xl:px-16 relative z-10">
        {/* Header of the footer */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#DFB587] block mb-3">
            Besøg Recars ApS
          </span>
          <h2 className="text-3xl sm:text-5xl font-light uppercase tracking-tight text-white font-display mb-4">
            Besøg os & Åbningstider
          </h2>
          <p className="text-sm text-neutral-400 leading-relaxed">
            Vi står altid klar til at byde dig velkommen hos os i Børkop. Kig forbi til en uforpligtende snak om din næste bil.
          </p>
        </div>

        {/* 3-Column Premium Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {/* Card 1: Firmainformation */}
          <div className="relative group border border-neutral-800 bg-neutral-900/40 backdrop-blur-sm p-8 sm:p-10 flex flex-col justify-between transition-all duration-300 hover:border-[#DFB587]/30 hover:bg-neutral-900/60">
            <div>
              <div className="flex h-12 w-12 items-center justify-center rounded-none bg-[#DFB587]/10 border border-[#DFB587]/20 text-[#DFB587] mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="fa-solid fa-building text-xl" />
              </div>
              <h3 className="text-lg font-bold text-white uppercase tracking-wider mb-4">
                Firmainformation
              </h3>
              <div className="space-y-2 text-sm text-neutral-400">
                <p className="font-semibold text-white">Recars ApS</p>
                <p>Industrivej 52</p>
                <p>7080 Børkop</p>
                <p className="pt-2 text-xs text-neutral-500">CVR-nummer: 44385171</p>
              </div>
            </div>
            <div className="mt-8">
              <a
                href="https://www.google.com/maps/place/Industrivej%2052,%207080%20B%C3%B8rkop"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#DFB587] hover:text-white transition-colors"
              >
                Find vej på kort <i className="fa-solid fa-location-dot" />
              </a>
            </div>
          </div>

          {/* Card 2: Kontakt os */}
          <div className="relative group border border-neutral-800 bg-neutral-900/40 backdrop-blur-sm p-8 sm:p-10 flex flex-col justify-between transition-all duration-300 hover:border-[#DFB587]/30 hover:bg-neutral-900/60">
            <div>
              <div className="flex h-12 w-12 items-center justify-center rounded-none bg-[#DFB587]/10 border border-[#DFB587]/20 text-[#DFB587] mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="fa-solid fa-phone-volume text-xl" />
              </div>
              <h3 className="text-lg font-bold text-white uppercase tracking-wider mb-4">
                Kontakt os
              </h3>
              <div className="space-y-3 text-sm text-neutral-400">
                <p className="flex items-center gap-3">
                  <i className="fa-solid fa-phone text-[#DFB587] text-xs" />
                  <a href="tel:+4571999177" className="hover:text-[#DFB587] transition-colors">
                    +45 71 99 91 77
                  </a>
                </p>
                <p className="flex items-center gap-3">
                  <i className="fa-solid fa-envelope text-[#DFB587] text-xs" />
                  <a href="mailto:info@recars.dk" className="hover:text-[#DFB587] transition-colors">
                    info@recars.dk
                  </a>
                </p>
                <p className="pt-2 text-xs text-neutral-500 leading-relaxed">
                  Kontakt os for et uforpligtende tilbud på køb, salg eller finansiering.
                </p>
              </div>
            </div>
            <div className="mt-8">
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#DFB587] hover:text-white transition-colors"
              >
                Send en besked <i className="fa-solid fa-paper-plane" />
              </Link>
            </div>
          </div>

          {/* Card 3: Åbningstider */}
          <div className="relative group border border-neutral-800 bg-neutral-900/40 backdrop-blur-sm p-8 sm:p-10 flex flex-col justify-between transition-all duration-300 hover:border-[#DFB587]/30 hover:bg-neutral-900/60">
            <div>
              <div className="flex h-12 w-12 items-center justify-center rounded-none bg-[#DFB587]/10 border border-[#DFB587]/20 text-[#DFB587] mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="fa-solid fa-clock text-xl" />
              </div>
              <h3 className="text-lg font-bold text-white uppercase tracking-wider mb-4">
                Åbningstider
              </h3>
              <div className="space-y-3 text-sm text-neutral-400">
                <div className="flex justify-between border-b border-neutral-800 pb-2">
                  <span>Mandag – Fredag:</span>
                  <span className="text-white font-semibold">9.00 – 16.00</span>
                </div>
                <div className="flex justify-between border-b border-neutral-800 pb-2">
                  <span>Lørdag:</span>
                  <span className="text-neutral-500 font-semibold">Lukket</span>
                </div>
                <div className="flex justify-between">
                  <span>Søndag:</span>
                  <span className="text-white font-semibold">10.00 – 13.00</span>
                </div>
              </div>
            </div>
            <div className="mt-8">
              <span className="text-xs text-neutral-500 italic">
                Eller efter aftale
              </span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-900 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-neutral-500">
          <p>© {new Date().getFullYear()} Recars ApS. Alle rettigheder forbeholdes.</p>
          <div className="flex gap-6">
            <Link to="/403" className="hover:text-neutral-300 transition-colors">403-fejlside</Link>
            <Link to="/ikke-eksisterende-side" className="hover:text-neutral-300 transition-colors">404-fejlside</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
